export const GORGIAS_SESSION_IDENTITY_QUERY_KEYS = {
  default: () => ['gorgiasSessionIdentity'] as const,
  createGuestEmailChallenge: () =>
    [...GORGIAS_SESSION_IDENTITY_QUERY_KEYS.default(), 'createGuestEmailChallenge'] as const,
  verifyGuestEmailChallenge: () =>
    [...GORGIAS_SESSION_IDENTITY_QUERY_KEYS.default(), 'verifyGuestEmailChallenge'] as const,
  createAuthenticatedSessionIdentity: () =>
    [...GORGIAS_SESSION_IDENTITY_QUERY_KEYS.default(), 'createAuthenticatedSessionIdentity'] as const,
};
